const { abstractResource } = require("./abstractResource");

const service = abstractResource("");

const User = {
  ...service("users"),
  get_form_user_invite() {
    return {
      email: null,
      first_name: null,
      last_name: null,
      group: 1,
      groups: [],
    };
  },

  get_form_user() {
    return {
      first_name: "",
      last_name: "",
      email: "",
    };
  },

  get_form_member() {
    return {
      email: null,
      fist_name: null,
      last_name: null,
      role: null,
    };
  },

  invite(formUserInvite) {
    return this.request({
      method: "POST",
      url: this.url + "invite/",
      data: formUserInvite,
    });
  },
};

const ClientObject = {
  ...service("get_applications"),
};
const Card = {
  ...service("cards"),

  get_stripe_key(cardId, nonce) {
    return this.request({
      method: "POST",
      url: this.url + cardId + "/stripe_key/",
      data: {nonce: nonce},
    });
  },
  
  get_form() {
    return {
      card_holder: null,
      type: null,
    };
  },
};
const CompanyAdmin = {
  ...service("companies"),
  get_form() {
    return {
      name: null,
      services: [],
      bank_external_user_id: null,
      bank_external_id: null,
      alternative_bridge_email: null,
    };
  },
};
const Company = {
  ...service("companies"),
  get_bank_form() {
    return {
      iban: null,
      bic: null,
      benefiary_first_name: null,
      benefiary_last_name: null,
      vat_exemption: false,
      bank_external_id: null,
      bank_name: null,
    };
  },

  get_company_form() {
    return {
      name: null,
      siret: null,
      phone: null,
      logo: null,
    };
  },
  get_filters() {
    return {
      active: {
        name: true,
        // number: false,
      },
      form: {
        name: null,
        // number: null,
      },
    };
  },

  get_form() {
    return {
      name: null,
      siret: null,
      phone: null,
      logo: null,
    };
  },

  bank(id, { data }) {
    return this.request({
      method: "POST",
      url: this.url + id + "/bank/",
      data,
    });
  },

  public(slug) {
    return this.request({
      method: "GET",
      url: this.url + "slugs/" + slug + "/public/",
      headers: {
        via: "public",
      },
    });
  },

  get_stripe_account(id) {
    return this.request({
      method: "GET",
      url: this.url + id + "/stripe_sync/",
    });
  },

  create_stripe_account(id, data) {
    return this.request({
      method: "POST",
      url: this.url + id + "/stripe_sync/",
      data,
    });
  },

  synchronize(id) {
    return this.request({
      method: "POST",
      url: this.url + id + "/synchronize/",
    });
  },
  create_bank_user(id) {
    return this.request({
      method: "POST",
      url: this.url + id + "/create_bank_user/",
    });
  },
  remove_synchronization(id) {
    return this.request({
      method: "POST",
      url: this.url + id + "/remove_synchronisation/",
    });
  },
};

const Group = {
  ...service("groups"),
};

const Service = {
  ...service("services"),
};

const AuthDomain = {
  ...service("auth/token"),

  get_form() {
    return {
      client_id: null,
      client_secret: null,
      grant_type: "client_credentials",
    };
  },

  async client_token_login(company_slug) {
    const client_object = await ClientObject.request({
      params: { company_slug },
    });
    const data = this.get_form();
    data.client_id = client_object.client_id;
    data.client_secret = client_object.client_secret;
    const form = new URLSearchParams(data);
    const { access_token: accessToken } = await this.create(form, {
      headers: {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      },
    });
    localStorage.setItem("company_token", accessToken);
  },
};

const NotificationsParameter = {
  ...service("notifications-parameters"),
  get_form() {
    return {
      email: null,
    };
  },

  get_params() {
    return {
      dkimName: "",
      dkimRecord: "",
      dkimStatus: "",
      spfRecord: "",
      spfStatus: "",
    };
  },
};

module.exports = {
  AuthDomain,
  ClientObject,
  Company,
  Group,
  NotificationsParameter,
  User,
  Service,
  CompanyAdmin,
  Card, 
};
